<template>
    <div class="pages">
        <van-form ref="formRef">
            <van-field
                v-model="form.materialSupplier"
                name="materialSupplier"
                label="领料供应商："
                placeholder=""
                readonly
                label-width="auto"
                input-align="right"
            />
            <van-field
                v-model="form.serialNumber"
                name="serialNumber"
                label="序号："
                placeholder=""
                readonly
                label-width="auto"
                input-align="right"
                style="margin-bottom: 8px;"
            />
            <van-field
                v-model="form.materialCode"
                name="materialCode"
                label="UPN(物料编码)："
                placeholder="请输入物料编码"
                label-width="auto"
                style="display: block;"
                class="is-required"
                maxlength="50"
                :rules="[{ required: true, message: '请输入物料编码' , trigger: 'onChange' }]"
            />
            <van-field
                v-model="form.issueNumber"
                name="issueNumber"
                label="发料数量："
                placeholder="请输入发料数量"
                label-width="auto"
                input-align="right"
                :rules="[{ required: true, message: '请输入发料数量' , trigger: 'onChange' }]"
                class="is-required"
                style="margin-bottom: 8px;"
                maxlength="10"
            />
            <van-field
                v-model="form.issueTime"
                name="issueTime"
                placeholder="请选择发料日期"
                readonly
                label-width="auto"
                input-align="right"
                :rules="[{ required: true, message: '请选择发料日期' , trigger: 'onChange' }]"
                style="margin-bottom: 8px;"
                @click-input="handleIssusTimeSelect"
            >
                <template #left-icon><i class="iconfont icon-calendar left-icon-issue-time"></i></template>
                <template #label><span style="color: #EC892E;">发料日期</span></template>
                <template #right-icon><van-icon name="arrow" size="14px" color="#C9C2BB" @click="handleIssusTimeSelect" /></template>
            </van-field>
            <!-- <van-field
                v-model="form.materialWarehouse"
                label="领料仓库："
                name="materialWarehouse"
                :placeholder="!form.materialWarehouse && oldForm.materialWarehouse ? oldForm.materialWarehouse : '请选择领料仓库'"
                readonly
                label-width="auto"
                input-align="right"
                :rules="[{ required: true, message: '请选择领料仓库' , trigger: 'onChange' }]"
                class="is-required"
                @click-input="handleMaterialWarehouseAndDeliveryLocationSelect({ type: 'WAREHOUSE_TYPE' , keyName: 'materialWarehouse' , descriptionName: '仓库' })"
            >
                <template #right-icon><van-icon name="arrow" size="14px" color="#C9C2BB" @click="handleMaterialWarehouseAndDeliveryLocationSelect({ type: 'WAREHOUSE_TYPE' , keyName: 'materialWarehouse' , descriptionName: '仓库' })" /></template>
            </van-field>
            <van-field
                v-model="form.deliveryLocation"
                label="送货地点："
                name="deliveryLocation"
                :placeholder="!form.deliveryLocation && oldForm.deliveryLocation ? oldForm.deliveryLocation : '请选择送货地点'"
                readonly
                label-width="auto"
                input-align="right"
                :rules="[{ required: true, message: '请选择送货地点' , trigger: 'onChange' }]"
                class="is-required"
                @click-input="handleMaterialWarehouseAndDeliveryLocationSelect({ type: 'DELIVERY_TYPE' , keyName: 'deliveryLocation' , descriptionName: '送货地点' })"
            >
                <template #right-icon><van-icon name="arrow" size="14px" color="#C9C2BB" @click="handleMaterialWarehouseAndDeliveryLocationSelect({ type: 'DELIVERY_TYPE' , keyName: 'deliveryLocation' , descriptionName: '送货地点' })" /></template>
            </van-field> -->
            <van-field
                v-model="form.materialWarehouse"
                label="领料仓库："
                name="materialWarehouse"
                :placeholder="!form.materialWarehouse && oldForm.materialWarehouse ? oldForm.materialWarehouse : '请选择领料仓库'"
                readonly
                label-width="auto"
                input-align="right"
                :rules="[{ required: true, message: '请选择领料仓库' , trigger: 'onChange' }]"
                class="is-required"
                @click-input="handleToWarehouseMapList({ keyName: 'materialWarehouse' , pagesTitle: '选择仓库' })"
            >
                <template #right-icon><van-icon name="arrow" size="14px" color="#C9C2BB" @click="handleToWarehouseMapList({ keyName: 'materialWarehouse' , pagesTitle: '选择仓库' })" /></template>
            </van-field>
            <van-field
                v-model="form.deliveryLocation"
                label="送货地点："
                name="deliveryLocation"
                :placeholder="!form.deliveryLocation && oldForm.deliveryLocation ? oldForm.deliveryLocation : '请选择送货地点'"
                readonly
                label-width="auto"
                input-align="right"
                :rules="[{ required: true, message: '请选择送货地点' , trigger: 'onChange' }]"
                class="is-required"
                @click-input="handleToWarehouseMapList({ keyName: 'deliveryLocation' , pagesTitle: '选择送货地点' })"
            >
                <template #right-icon><van-icon name="arrow" size="14px" color="#C9C2BB" @click="handleToWarehouseMapList({ keyName: 'deliveryLocation' , pagesTitle: '选择送货地点' })" /></template>
            </van-field>
            <van-field
                v-model="form.hqMaterialCode"
                label="华勤料号："
                name="hqMaterialCode"
                placeholder="请输入华勤料号"
                label-width="auto"
                input-align="right"
                maxlength="50"
            ></van-field>
            <van-field
                v-model="form.inUseProject"
                label="在用项目："
                name="inUseProject"
                placeholder="请输入在用项目"
                label-width="auto"
                input-align="right"
                maxlength="50"
            ></van-field>
            <van-field
                v-model="form.workCenter"
                label="工作中心："
                name="workCenter"
                placeholder="请输入工作中心代码"
                label-width="auto"
                input-align="right"
                maxlength="50"
            ></van-field>
            <van-field
                v-model="form.materialType"
                label="物料类别："
                name="materialType"
                placeholder="请输入物料类别"
                label-width="auto"
                input-align="right"
                maxlength="100"
            ></van-field>
            <van-field
                v-model="form.materialDescription"
                label="物料描述："
                name="materialDescription"
                placeholder="请输入物料描述"
                label-width="auto"
                input-align="right"
                style="margin-bottom: 8px;"
                maxlength="100"
            ></van-field>
            <van-field
                v-model="form.remark"
                label="备注："
                name="remark"
                placeholder="请输入备注"
                label-width="auto"
                input-align="right"
                style="margin-bottom: 8px;"
                maxlength="200"
            ></van-field>
        </van-form>
        <div class="footer">
            <van-button
                type="warning"
                plain
                @click="handleCancel"
            >取消</van-button>
            <van-button
                type="warning"
                class="submit-button"
                @click="handleSubmit"
            >{{ submitButtonText }}</van-button>
        </div>
        <date-time-picker-popup ref="dateTimePickerPopupRef" />
        <action-sheet ref="actionSheetRef" />
    </div>
</template>

<script>
import { parseTime } from "@/utils/index.js";
import { getMaterialWarehouseAndDeliveryLocation , verifyMaterialCodeExist } from "@/api/material/materialDataUpload/addEdit/index.js";
import { Form , Field , Icon , Button , Toast } from "vant";
import dateTimePickerPopup from "./components/date-time-picker-popup.vue";
import actionSheet from "@/view/material/materialDataUpload/components/action-sheet.vue";
let _this = this;
export default {
    components:{
        [Form.name]: Form,
        [Field.name]: Field,
        [Icon.name]: Icon,
        [Button.name]: Button,
        [Toast.name]: Toast,
        dateTimePickerPopup,
        actionSheet
    },
    data(){
        return {
            form: {
                materialSupplier: "",
                serialNumber: null,
                materialCode: "",
                issueNumber: "",
                issueTime: "",
                materialWarehouse: "",
                deliveryLocation: "",
                workCenter: "",
                materialType: "",
                materialDescription: "",
                remark: "",
                hqMaterialCode: "",
                inUseProject: ""
            },
            oldForm: {},
            submitButtonText: "确认",
            routeQuery: {},
            initialData: {}
        }
    },
    beforeRouteEnter(to , from , next){
        console.log("addEdit beforeRouteEnter",{from,to,_this: _this && _this.init});
        // 只有跳转到选择仓库页面才缓存当前的表单页
        if(["/material/materialDataUpload"].includes(from.path)) {
            _this && _this.init &&_this.init();
        };
        next()
    },
    created(){
        this.initialData = this.deepClone(this.$data);
        _this = this;
        this.$bus.on("warehouseSelectFinish",this.warehouseSelectFinish);
        console.log("addEdit created")
        this.init();
    },
    activated(){
        console.log("addEdit activated");
        if(process.env.NODE_ENV === "development") {
            window.addEditThis = this;
        }
    },
    beforeDestroy(){
        console.log("addEdit beforeDestroy")
        this.$bus.off("warehouseSelectFinish",this.warehouseSelectFinish);
        _this = null;
    },
    destroyed(){
        console.log("addEdit destroyed")
    },
    // computed:{
    //     dataUploadAddEditQuery(){
    //         return this.$store.state.material.dataUploadAddEditQuery;
    //     }
    // },
    methods: {
        async init(){
            let dataUploadAddEditQuery = this.$store.state.material.dataUploadAddEditQuery;
            this.form = this.deepClone({ ...this.initialData.form, ...dataUploadAddEditQuery.form });
            if(this.form.materialCode) {
                document.title = "修改领料数据";
                this.submitButtonText = "确认修改";
                this.oldForm = dataUploadAddEditQuery.oldForm ? this.deepClone(dataUploadAddEditQuery.oldForm) : {};
            }else {
                document.title = "手动录入数据";
                this.submitButtonText = "确认录入";
            };
            this.routeQuery = this.deepClone(this.$route.query);
            await this.$sleep(50);
            this.$refs.formRef.resetValidation();
        },
        // 仓库/送货地点选择完成
        warehouseSelectFinish(data){
            console.log("选择完成",data && this.deepClone(data));
            this.$set(this.form,data.keyName,data.twoData[0].name);
            console.log("set form",this.deepClone(this.form));
        },
        handleToWarehouseMapList(query){
            this.$router.push({ 
                path: "/material/warehouseMapList",
                query: this.deepClone({
                    ...this.routeQuery,
                    ...query,
                    singleMultiple: "single"
                })
             });
        },
        handleCancel(){
            this.$router.back();
        },
        async validate(){
            try {
                // 表单必填项校验 
                await this.$refs.formRef.validate();
                // 前端：物料编码唯一性校验，前端校验的是当前 Excel 中是否唯一
                /* let isExistIndex = this.$store.state.material.excelFileToJsonData.tableData.findIndex(row => {
                    let cellActive = row.colData.find(cell => cell.keyName === "materialCode");
                    let materialCodeValue = cellActive && cellActive.value;
                    return materialCodeValue === this.form.materialCode;
                });
                if(~isExistIndex && (isExistIndex+1) !== +this.form.serialNumber) {
                    throw [{message: `物料编码存在表 ${isExistIndex+1} 行，无需重复录入`}];
                } */
                // 后端：物料编码唯一性校验，后端校验的是数据库中是否唯一
                /* let { data: isExist } = await verifyMaterialCodeExist({
                    materialSupplier: this.form.materialSupplier,
                    materialCode: this.form.materialCode,
                });
                if(isExist === 1) {
                    throw [{message: "系统已存在，无需重复录入"}];
                } */
                return Promise.resolve(true);
            } catch (error) {
                console.log("校验失败",error);
                this.$toast({
                    message: error[0].message,
                    position: "top"
                });
                return Promise.reject(error);
            }
        },
        async handleSubmit(){
            await this.validate();
            let form = this.deepClone(this.form);
            Object.keys(form).forEach(key => {
                if(form[key] && typeof form[key] === "string") form[key] = form[key].trim();
            })
            this.$bus.emit("materialDataFormSubmit",form);
            this.$router.back();
        },
        // 选择发料日期
        async handleIssusTimeSelect(){
            let options = {
                type: "date",
            };
            if(this.form.issueTime) {
                options.currentDate = new Date(this.form.issueTime.replace(/-/g,"/"));
            };
            let date = await this.$refs.dateTimePickerPopupRef.init(options);
            this.$set(this.form,"issueTime",parseTime(date,"{y}-{m}-{d}"));
        },
        // 选择仓库/送货地址
        async handleMaterialWarehouseAndDeliveryLocationSelect({ type , keyName , descriptionName }){
            this.$loading.open();
            let name = "";
            // 获取一级仓库列表
            let { data: data1 } = await getMaterialWarehouseAndDeliveryLocation({ type , parent: 0 });
            // 选择一级仓库
            let { name: name1 , id: id1 } = await this.$refs.actionSheetRef.init({
                list: data1,
                description: `选择一级${descriptionName}`,
                cancelText: "取消"
            });
            name += `${name1} `;

            this.$loading.open();
            await this.$sleep(500);
            // 获取二级仓库列表
           let { data: data2 } = await getMaterialWarehouseAndDeliveryLocation({ type , parent: id1 });
            // 选择二级仓库
            let { name: name2 , id: id2 } = await this.$refs.actionSheetRef.init({
                list: data2,
                description: `选择二级${descriptionName}`,
                cancelText: "取消"
            });
            name += `${name2} `;

            this.$loading.open();
            await this.$sleep(500);
            // 获取三级仓库列表
           let { data: data3 } = await getMaterialWarehouseAndDeliveryLocation({ type , parent: id2 });
            // 选择三级仓库
            let { name: name3 } = await this.$refs.actionSheetRef.init({
                list: data3,
                description: `选择三级${descriptionName}`,
                cancelText: "取消"
            });
            name += name3;
            this.$set(this.form,keyName,name3);
        },
    }
}
</script>

<style scoped lang="scss">
    .footer {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
        background-color: #FFF;
        padding-top: 16px;
        padding-left: 32px;
        padding-right: 32px;
        padding-bottom: calc(constant(safe-area-inset-bottom) + 8px);
        padding-bottom: calc(env(safe-area-inset-bottom) + 8px);
        display: flex;
        align-items: center;
        justify-content: space-between;
        .van-button {
            min-width: 122px;
            height: 38px;
            border-radius: 4px;
            overflow: hidden;
            font-size: 16px;
        }
        .van-button--warning {
            background-color: #EC892E;
            border-color: #EC892E;
            color: #FFF;
        }
        .van-button--plain {
            background-color: #FFF;
            border-color: #EC892E;
            color: #EC892E;
        }
    }
    ::v-deep.van-cell {
        padding: 12px 28px;
    }
    ::v-deep .van-field__error-message {
        display: none;
    }
    .is-required {
        ::v-deep .van-field__label {
            position: relative;
            &::before {
                content: "*";
                color: #FF3838;
                position: absolute;
                left: -6px;
                top: -4px;
                font-size: 20px;
            }
        }
    }
    .left-icon-issue-time {
        font-size: 14px;
        color: #EC892E;
        margin-right: 4px;
        position: relative;
        &:after {
            content: "*";
            color: #FF3838;
            position: absolute;
            left: -10px;
            top: -8px;
            font-size: 20px;
        }
    }
</style>